import React, { useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const generateColors = (count) => {
  const colors = [];
  const hue = Math.random() * 360;

  for (let i = 0; i < count; i++) {
    const hueValue = (hue + (i * 360) / count) % 360;
    const color = `hsl(${hueValue}, 70%, 65%)`;
    colors.push(color);
  }
  return colors;
};

const DoughnutReport = () => {
  const [timeFrame, setTimeFrame] = useState("Daily");

  const labels = ["Accra", "Kumasi", "Cape Coast"];
  const backgroundColors = generateColors(labels.length);

  const data = {
    labels: labels,
    datasets: [
      {
        data:
          timeFrame === "Daily"
            ? [30, 20, 50]
            : timeFrame === "Weekly"
            ? [210, 140, 350]
            : [900, 600, 1500],
        backgroundColor: backgroundColors,
        hoverBackgroundColor: backgroundColors.map((color) => {
          return color.replace("65%", "55%");
        }),
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "top",
        display: false,
      },
    },
    maintainAspectRatio: false,
    cutout: "75%",
  };

  return (
    <div className="px-4 py-4 bg-white rounded-lg shadow-md">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-sm font-semibold">Top Redemption Location</h2>
        <select
          value={timeFrame}
          onChange={(e) => setTimeFrame(e.target.value)}
          className="px-3 py-2 text-sm text-gray-700 bg-white rounded-md border focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option className="hover:bg-[#FF6C6C] hover:text-white" value="Daily">
            Daily
          </option>
          <option
            className="hover:bg-[#FF6C6C] hover:text-white"
            value="Weekly"
          >
            Weekly
          </option>
          <option
            className="hover:bg-[#FF6C6C] hover:text-white"
            value="Monthly"
          >
            Monthly
          </option>
        </select>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-16 md:grid-cols-3">
        {data.labels.map((label, index) => (
          <div
            key={label}
            className="flex col-span-1 items-center text-xs text-gray-500"
          >
            <div
              className="mr-1 w-3 h-3 rounded-full"
              style={{
                backgroundColor: data.datasets[0].backgroundColor[index],
              }}
            ></div>
            <span>{label}</span>
          </div>
        ))}
      </div>

      <div className="flex relative justify-center items-center my-4 h-64">
        <div className="absolute w-[280px] h-[280px] bg-gray-100 rounded-full flex items-center justify-center p-8">
          <div className="bg-white rounded-full h-[150px] w-[150px]"></div>
          <div className="absolute w-[90%] h-[90%]">
            <Doughnut data={data} options={options} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoughnutReport;
